<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Типы контрагентов</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item page__search">
            <SearchForm :value="searchValue"
                        @form-submit="setSearchValue"
            />
          </div>
        </div>
        <div class="page__item">
          <div class="page__row">
            <transition name="fade" v-if="roleAccessRemove">
              <div class="page__item" v-if="isActiveDelete" >
                <AppButtonSmRemove title="Удалить" @click.stop.native="showRemoveConfirmationGroup" />
              </div>
            </transition>
            <div class="page__item" v-if="roleAccessCreate">
              <AppButtonSmAdd title="Создать"  @click.stop.native="showModal(null)" />
            </div>
          </div>
        </div>
      </div>
      <div class="page__table mb-20" v-if="types.length !== 0">
        <AppTable :data="types"
                  :headers="tableHeaders.headers"
                  :has-checkbox="roleAccessRemove"
                  :isMenuControlsActive=false
                  :all-items-active="tableHeaders.allActive"
                  @toggle-active-item="toggleActiveItem"
                  @toggle-active-all="toggleActiveAll"
                  @edit-this-item="showModal"
                  @show-this-item="showModal"
                  @remove-this-item="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20"  v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="Записи не найдены"/>
        </div>
      </div>
    </section>

    <section class="section page__footer page__footer_has-pagination">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade">
      <AppConfirmation v-if="removeConfirmation.active && roleAccessRemove"
                       :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти типы?' : 'Вы действительно хотите удалить этот тип?'"
                       @confirm="removeConfirmation.group ? removeContractorsTypeGroup() : removeContractorsType()"
                       @reject="closeRemoveConfirmation"
      />
      <ContractorTypeModal v-if="modal.active && roleAccessEdit"
                             :state="modal"
                             @set-item-name="setContractorTypeItemName"
                             @clear-validation="clearModalValidation"
                             @save-item-info="saveContractorTypeItem"
                             @close-modal="closeModal"
      />
      <AppModal v-if="deleteResponseModal.isActive && !deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModal.title"
                :text="deleteResponseModal.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModal.type"
                @confirm="closeDeleteModal"
      />
      <AppModal v-if="deleteResponseModalWithTreaties.isActive && roleAccessRemove"
                :title="deleteResponseModalWithTreaties.title"
                :text="deleteResponseModalWithTreaties.text"
                confirmButtonTitle="Ок"
                :confirmButtonType="deleteResponseModalWithTreaties.type"
                @confirm="closeDeleteModalWithTreaties"
      />
    </transition>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import ContractorTypeModal from '@/components/contractor/ContractorTypeModal'
import AppModal from '@/components/page/modal/AppModal'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import VPagination from '@/components/page/VPagination'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractorsTypeList',
  components: {
    ContractorTypeModal,
    ThePagePreloader,
    AppConfirmation,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmAdd,
    SearchForm,
    AppButtonSmRemove,
    AppModal,
    VPagination
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      }
    }
  },
  computed: {
    ...mapGetters('contractorTypeListPage', [
      'getContractorsTypeListTableHeaders',
      'getContractorsTypeList',
      'getContractorsTypeListModal',
      'getContractorsTypeListSearchValue',
      'getContractorsTypeListFilter',
      'getContractorsTypeListPagination',
      'getContractorsTypeListIsLoading',
      'getContractorsTypeListResponseModal',
      'getContractorsTypeListResponseModalWithTreaties',
      'getContractorsTypeListActiveDelete'
    ]),

    tableHeaders () {
      return this.getContractorsTypeListTableHeaders
    },
    types () {
      return this.getContractorsTypeList.map(type => {
        return ({
          id: type.id,
          isActive: type.isActive,
          values: [
            type.name
          ]
        })
      })
    },
    modal () {
      return this.getContractorsTypeListModal
    },
    searchValue () {
      return this.getContractorsTypeListSearchValue
    },
    filter () {
      return this.getContractorsTypeListFilter
    },
    pagination () {
      return this.getContractorsTypeListPagination
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isLoading () {
      return this.getContractorsTypeListIsLoading
    },
    deleteResponseModal () {
      return this.getContractorsTypeListResponseModal
    },
    deleteResponseModalWithTreaties () {
      return this.getContractorsTypeListResponseModalWithTreaties
    },
    isActiveDelete () {
      return this.getContractorsTypeListActiveDelete
    },
    roleAccessCreate () {
      return this.$store.getters.getRoleRightContractors.actions.add
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContractors.actions.remove
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightContractors.actions.update
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('contractorTypeListPage/toggleContractorsTypeListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('contractorTypeListPage/toggleContractorsTypeListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('contractorTypeListPage/toggleContractorsTypeListItemActiveAll')
    },
    showModal (itemId) {
      this.$store.dispatch('contractorTypeListPage/showContractorsTypeModal', itemId)
    },
    setContractorTypeItemName (value) {
      this.$store.dispatch('contractorTypeListPage/setContractorsTypeItemName', value)
    },
    clearModalValidation (inputName) {
      this.$store.dispatch('contractorTypeListPage/clearContractorsTypeModalValidation', inputName)
    },
    saveContractorTypeItem () {
      this.$store.dispatch('contractorTypeListPage/saveContractorsTypeItem')
    },
    closeModal () {
      this.$store.dispatch('contractorTypeListPage/closeContractorsTypeModal')
    },
    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeContractorsType () {
      const itemId = this.removeConfirmation.id
      this.$store.dispatch('contractorTypeListPage/removeContractorsType', itemId)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeContractorsTypeGroup () {
      this.$store.dispatch('contractorTypeListPage/deleteContractorsTypeListCheckedItems')
      this.removeConfirmation.active = false
      this.removeConfirmation.group = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    closeDeleteModal () {
      this.$store.dispatch('contractorTypeListPage/closeContractorsTypeListDeleteModal')
    },
    closeDeleteModalWithTreaties () {
      this.$store.dispatch('contractorTypeListPage/closeContractorsTypeListDeleteModalWithTreaties')
    },

    // search
    setSearchValue (value) {
      this.$store.dispatch('contractorTypeListPage/setContractorsTypeListSearchValue', value)
    },

    // filter

    // pagination
    togglePageList () {
      this.$store.dispatch('contractorTypeListPage/toggleContractorsTypeListPageList')
    },
    previousPage () {
      this.$store.dispatch('contractorTypeListPage/getContractorsTypeListPrevPage')
    },
    nextPage () {
      this.$store.dispatch('contractorTypeListPage/getContractorsTypeListNextPage')
    },
    getPage (pageNum) {
      this.$store.dispatch('contractorTypeListPage/getContractorsTypeListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('contractorTypeListPage/getContractorsType')
  },

  destroyed () {
    this.$store.commit('contractorTypeListPage/RESET_CONTRACTORS_TYPE_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.no-records {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  display: flex;
}
</style>
